<header-title [model]="headerTitle"></header-title>

<section class="card mt-4" *ngIf="auditTemplateDetailsModel">
    <header class="card-header">
        <h3 class="text-gray-600"><i class="fas fa-tasks me-2"></i>Audit Template : {{auditTemplateDetailsModel.description}}</h3>
    </header>
    <div class="card-body py-5">
        <div class="container">
            <div class="tab-navigation">
                <nav>
                    <ul class="nav nav-tabs">
                        <li class="nav-item">
                            <a class="nav-link text-muted" [routerLink]="['/audit-template', auditTemplateId]">
                                <i class="fas fa-building me-2" aria-hidden="true"></i>Audit Template Details
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link active text-primary">
                                <i class="fas fa-cubes me-2" aria-hidden="true"></i>Audit Template Modules
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
            <error-message [errors]="errors"></error-message>
            <div class="row mt-3">
                <div class="col-12 text-end">
                    <button *ngIf="!isAddMode" class="btn btn-primary" type="button" (click)="toggleAddMode()">Add Module</button>
                    <button *ngIf="isAddMode" class="btn btn-outline-primary" type="button" (click)="toggleAddMode()">Cancel</button>
                </div>
            </div>
            <div class="row mt-3" *ngIf="!isAddMode">
                <div class="col-12">
                    <app-audit-template-modules-list [auditTemplateId]="auditTemplateId"></app-audit-template-modules-list>
                </div>
            </div>
            <div class="row mt-3" *ngIf="isAddMode">
                <div class="col-12">
                    <app-audit-template-module-add [auditTemplateId]="auditTemplateId" (auditTemplateModuleAdded)="auditTemplateModuleAdded($event);" ></app-audit-template-module-add>
                </div>
            </div>
        </div>
    </div>
</section>
